import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../utils/cn';
import primaryLogo from '../assets/images/PRIMARY-LOGO..png';

interface BrandLogoProps {
  className?: string;
  showSecondaryText?: boolean;
}

const BrandLogo: React.FC<BrandLogoProps> = ({ 
  className,
  showSecondaryText = true
}) => {
  return (
    <Link 
      to="/"
      className={cn(
        "flex items-center gap-3",
        className
      )}
      aria-label="Bass Ministry - Home"
    >
      <img 
        src={primaryLogo} 
        alt="Bass Ministry Logo" 
        className="h-16 w-auto rounded-[50%] border-[solid] "
      />
      {showSecondaryText && (
        <span className="text-md font-extrabold text-white/80  drop-shadow-[0px_0px_5px_rgba(255,162,0,1)]">
          BASSMINISTRY 2025
        </span>
      )}
    </Link>
  );
};

export default BrandLogo; 